<template>
  <div class="alarmAnalysisWrap">
    <div class="timeBox">
      <el-form :inline="true" size="small" style="margin-left: 20px">
        <el-form-item label="周期">
          <el-select v-model="timeType" @change="getDataValue">
            <el-option label="月" value="MONTH"></el-option>
            <el-option label="年" value="YEAR"></el-option>
            <el-option label="全部" value="ALL"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" v-if="timeType !== 'ALL'">
          <el-date-picker
            size="small"
            :clearable="false"
            v-model="timeValue"
            :type="timeType == 'MONTH' ? 'month' : 'year'"
            :key="timeType == 'MONTH' ? 'month' : 'year'"
            :placeholder="timeType == 'MONTH' ? '选择月' : '选择年'"
            :value-format="timeType == 'MONTH' ? 'yyyy-MM' : 'yyyy'"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="analysisBox ashComWrap">
      <div class="comTitle">
        <h4>报警分析</h4>
      </div>
      <div class="comContentBox analysis">
        <div class="classification">
          <h5>总览</h5>
          <div class="content dataList">
            <div class="totalBox">
              <h6>39000</h6>
              <p>报警总数</p>
            </div>
            <ul>
              <li>同比 +23%</li>
              <li>环比 +23%</li>
            </ul>
          </div>
        </div>
        <div class="classification">
          <h5>报警等级分析</h5>
          <div class="content">
            <AnalysisCharts :id="'grade'" />
          </div>
        </div>
        <div class="classification">
          <h5>确认状态分析</h5>
          <div class="content">
            <UniversalRing :id="'state'" :chartsData="stateData" />
          </div>
        </div>
        <div class="classification">
          <h5>转工单分析</h5>
          <div class="content">
            <UniversalRing :id="'order'" :chartsData="orderData" />
          </div>
        </div>
      </div>
    </div>
    <div class="chartBox">
      <div class="chart ashComWrap">
        <div class="comTitle">
          <h4>24小时报警趋势</h4>
        </div>
        <div class="comContentBox">
          <CurrencyBar :id="'myCharts'" :chartsData="chartsData" />
        </div>
      </div>
      <div class="chart ashComWrap">
        <div class="comTitle">
          <h4>每日/每月/每年报警趋势</h4>
        </div>
        <div class="comContentBox">
          <CurrencyBar :id="'myCharts1'" :chartsData="chartsData1" />
        </div>
      </div>
    </div>
    <div class="formBox ashComWrap">
      <div class="comTitle">
        <h4>报表详情页</h4>
        <el-button type="primary" size="mini" 
          >导出</el-button
        >
      </div>
      <div class="comContentBox">
        <el-table
          :data="tableData"
          height="100%"
          border
          stripe
          style="width: 100%"
          :header-cell-style="{
            'font-weight': 'bold',
            color: '#333',
            'background-color': '#F7F7F7',
          }"
          size="small"
        >
          <el-table-column
            v-for="(v, i) in tabHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
import CurrencyBar from "@/components/CurrencyBar";

import AnalysisCharts from "@/components/shebeiguanli/baojingguanli/AnalysisCharts";
import UniversalRing from "@/components/shebeiguanli/baojingguanli/UniversalRing";
export default {
  components: {
    CurrencyBar,
    AnalysisCharts,
    UniversalRing,
  },
  data() {
    return {
      timeValue: "",
      timeType: "MONTH",
      tableData: [
        { time: "2022-01", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
        { time: "2022-02", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
        { time: "2022-03", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
        { time: "2022-04", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
        { time: "2022-05", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
        { time: "2022-06", num: 20, a: 3, b: 3, c: 3, d: 3, e: 3, f: 3 },
      ],
      tabHead: [
        { label: "时间", prop: "time" },
        { label: "报警数量", prop: "num" },
        { label: "紧急", prop: "a" },
        { label: "重要", prop: "b" },
        { label: "一般", prop: "c" },
        { label: "转工单", prop: "d" },
        { label: "已确认", prop: "e" },
        { label: "未确认", prop: "f" },
      ],
      chartsData: {
        title: "24小时报警趋势",
        unit: "次",
        xData: [],
        dataArr: [],
      },
      chartsData1: {
        title: "24小时报警趋势",
        unit: "次",
        xData: [],
        dataArr: [],
      },
      analysisList: [{ name: 1, value: 1 }],
      orderData: [],
      stateData: [],
    };
  },
  methods: {
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
      } else if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
      } else {
        this.timeValue = null;
      }
    },
    onSubmit() {},
    getChartsData() {
      setTimeout(() => {
        this.chartsData.xData = [
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
        ];
        this.chartsData.dataArr = [6, 9, 10, 23, 15, 26, 35, 21, 22, 53, 12];
        this.chartsData1.xData = [
          "1日",
          "2日",
          "3日",
          "4日",
          "5日",
          "6日",
          "7日",
          "8日",
          "9日",
          "10日",
          "11日",
          "12日",
          "13日",
          "14日",
          "15日",
        ];
        this.chartsData1.dataArr = [
          16, 92, 40, 23, 125, 126, 35, 31, 72, 53, 123, 35, 72, 34, 65,
        ];
        this.stateData = [
          { name: "已确认", value: 48 },
          { name: "未确认", value: 39 },
        ];
        this.orderData = [
          { name: "已转工单", value: 20 },
          { name: "未转工单", value: 16 },
        ];
      }, 50);
    },
  },
  created() {
    this.getDataValue();
    this.getChartsData();
  },
};
</script>

<style lang="scss" scoped>
.alarmAnalysisWrap {
  width: 100%;
  overflow: auto;
  .timeBox {
    width: 95%;
    margin: 0 auto;
    height: 60px;
    @include setFlexStart;
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }
  .analysisBox {
    width: 95%;
    height: 350px;
    margin: 10px auto;
    .analysis {
      // width: 98%;
      margin: 0 auto;
      @include setFlexAround;
      .classification {
        width: 24%;
        height: 100%;
        h5 {
          font-size: 20px;
          text-indent: 10px;
          border-left: 5px solid #28cccb;
          margin: 10px 0;
        }
        .content {
          width: 100%;
          height: 85%;
        }
        .dataList {
          @include setFlexCenter;
          .totalBox {
            width: 30%;
            height: 60%;
            text-align: center;
            h6 {
              font-size: 22px;
              margin-bottom: 20px;
            }
          }
          ul {
            width: 50%;
            height: 60%;
            text-indent: 30px;
            li:nth-child(1) {
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }
  .chartBox {
    width: 95%;
    height: 400px;
    margin: 0 auto;
    @include setFlexBetween;
    .chart {
      width: 49.5%;
      height: 100%;
    }
  }
  .formBox {
    width: 95%;
    margin: 10px auto;
    height: 400px;
    background: #fff;
  }
}
</style>
